import ApplicationController from '../../application_controller'

// Loads the Recent Activity fragment on connect, from the existing privacy-checked
// profile_activity_feed endpoint (version=3 selects the v3 partials server-side).
export default class extends ApplicationController {
  static values = { url: String }

  connect() {
    super.connect()
    this.load()
  }

  load() {
    fetch(this.urlValue, {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
    })
      .then(response => response.json())
      .then(data => {
        this.element.innerHTML = data.opportunities || ''
      })
      .catch(error => {
        console.error('[user-profile--activity-feed] failed to load activity feed:', error)
      })
  }
}
